export const values = [
  {
    '#': '1',
    Library: 'abs-svg-path-0.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: '2013 Copyright (c) Jake Rosoman jkroso@gmail.com'
  },
  {
    '#': '2',
    Library: 'apollo-link-debounce-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017-2018 Jonas Helfer'
  },
  {
    '#': '3',
    Library: 'babel-plugin-11.13.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '4', Library: 'babel-plugin-macros-3.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Kent C'},
  {'#': '5', Library: 'base-5.0.0-beta.40-1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '6', Library: 'base64-js-0.0.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014'},
  {Copyrights: 'Copyright 2014'},
  {Copyrights: 'Copyright 2014 (c)'},
  {'#': '7', Library: 'base64-js-1.5.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Jameson Little'},
  {Copyrights: 'Copyright 2014 Jameson Little'},
  {'#': '8', Library: 'bidi-js-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Jason Johnston'},
  {'#': '9', Library: 'brotli-1.3.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright https://www.npmjs.com/~devongovett'},
  {
    '#': '10',
    Library: 'browserify-zlib-0.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2015 Devon Govett <devongovett@gmail.com>'
  },
  {
    '#': '11',
    Library: 'cache-11.14.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {
    '#': '12',
    Library: 'caches-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'
  },
  {
    '#': '13',
    Library: 'call-bind-apply-helpers-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Jordan Harband'
  },
  {'#': '14', Library: 'call-bound-1.0.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {
    '#': '15',
    Library: 'callsites-3.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '16',
    Library: 'ciphers-1.3.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 Thomas Pornin "pornin@bolet.org" (mailto:pornin@bolet.org)'
  },
  {Copyrights: 'Copyright 2022 Paul Miller (https://paulmillr.com)'},
  {Copyrights: 'Copyright 2023 Paul Miller "(https://paulmillr.com)" (https://paulmillr.com)'},
  {Copyrights: 'Copyright 2016 Thomas Pornin <pornin@bolet.org>'},
  {'#': '17', Library: 'client-3.14.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2022 Apollo Graph, Inc'},
  {'#': '18', Library: 'clone-2.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Paul Vorbach'},
  {
    '#': '19',
    Library: 'clsx-2.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {
    '#': '20',
    Library: 'code-frame-7.29.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '21', Library: 'color-name-1.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dmitry Ivanov'},
  {
    '#': '22',
    Library: 'color-string-1.9.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2011 Heather Arthur <fayearthur@gmail.com>'
  },
  {'#': '23', Library: 'context-0.7.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2023  Ben Newman'},
  {'#': '24', Library: 'convert-source-map-1.9.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Thorsten Lorenz'},
  {Copyrights: 'Copyright 2013 Thorsten Lorenz'},
  {
    '#': '25',
    Library: 'copy-to-clipboard-3.3.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 sudodoki <smd.deluzion@gmail.com>'
  },
  {Copyrights: 'Copyright 2017 sudodoki <smd.deluzion@gmail.com>'},
  {'#': '26', Library: 'core-1.7.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '27', Library: 'core-2.11.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Federico Zivolo'},
  {'#': '28', Library: 'core-3.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020-2023 Dotan Simha'},
  {'#': '29', Library: 'core-downloads-tracker-5.18.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '30', Library: 'cosmiconfig-7.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 David Clark'},
  {Copyrights: 'Copyright 2015 David Clark'},
  {'#': '31', Library: 'csstype-3.2.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017-2018 Fredrik Nicol'},
  {'#': '32', Library: 'dayjs-1.11.20.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 iamkun'},
  {
    '#': '33',
    Library: 'debug-4.4.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2017 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {Copyrights: 'Copyright 2014-2017 TJ Holowaychuk <tj@vision-media.ca>'},
  {Copyrights: 'Copyright 2018-2021 Josh Junon'},
  {Copyrights: 'Copyright 2018-2021 Josh Junon'},
  {
    '#': '34',
    Library: 'dequal-2.0.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {'#': '35', Library: 'dfa-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Devon Govett devongovett@gmail.com'},
  {'#': '36', Library: 'dom-1.7.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '37', Library: 'dom-helpers-5.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Jason Quense'},
  {
    '#': '38',
    Library: 'dom-serializer-2.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 The cheeriojs contributors'
  },
  {'#': '39', Library: 'domelementtype-2.3.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright Felix Böhm'},
  {'#': '40', Library: 'domhandler-5.0.3.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright Felix Böhm'},
  {'#': '41', Library: 'dompurify-3.4.0.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2025 Dr'},
  {'#': '42', Library: 'domutils-3.2.2.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright Felix Böhm'},
  {'#': '43', Library: 'dunder-proto-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 ECMAScript Shims'},
  {'#': '44', Library: 'emoji-regex-xs-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Steven Levithan'},
  {'#': '45', Library: 'entities-4.5.0.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright Felix Böhm'},
  {'#': '46', Library: 'entities-7.0.1.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright Felix Böhm'},
  {'#': '47', Library: 'equality-0.5.7.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Ben Newman'},
  {'#': '48', Library: 'error-ex-1.3.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '49', Library: 'es-define-property-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {'#': '50', Library: 'es-errors-1.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {'#': '51', Library: 'es-object-atoms-1.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {
    '#': '52',
    Library: 'escape-string-regexp-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {
    '#': '53',
    Library: 'events-3.3.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Joyent, Inc. and other Node contributors'
  },
  {Copyrights: 'Copyright Joyent, Inc. and other Node contributors'},
  {'#': '54', Library: 'fast-deep-equal-3.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Evgeny Poberezkin'},
  {Copyrights: 'Copyright 2017 Evgeny Poberezkin'},
  {
    '#': '55',
    Library: 'file-saver-2.0.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 "Eli Grey" (http://eligrey.com)'
  },
  {'#': '56', Library: 'find-root-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 jsdnxx'},
  {Copyrights: 'Copyright 2017 jsdnxx'},
  {
    '#': '57',
    Library: 'fns-3.1.3.tgz',
    Licenses: 'MIT',
    Copyrights:
      'Copyright Diego Muracciole FOSSA Status 2Bgithub.com 2Fdiegomura 2Freact-pdf.svg?type large 2Bgithub.com'
  },
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {'#': '58', Library: 'font-4.0.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2026 diegomuracciole@gmail.com'},
  {'#': '59', Library: 'fontkit-2.0.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright -'},
  {'#': '60', Library: 'function-bind-1.1.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Raynos'},
  {
    '#': '61',
    Library: 'gen-mapping-0.3.13.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Justin Ridgewell <justin@ridgewell.name>'
  },
  {
    '#': '62',
    Library: 'generator-7.29.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '63', Library: 'get-intrinsic-1.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Jordan Harband'},
  {'#': '64', Library: 'get-proto-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2025 Jordan Harband'},
  {'#': '65', Library: 'gopd-1.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2022 Jordan Harband'},
  {'#': '66', Library: 'graphql-16.13.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright GraphQL Contributors'},
  {'#': '67', Library: 'graphql-tag-2.12.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Apollo Graph, Inc'},
  {'#': '68', Library: 'has-symbols-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Jordan Harband'},
  {'#': '69', Library: 'hash-0.9.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Emotion team and other contributors'},
  {Copyrights: 'Copyright 2016 Kye Hohenberger'},
  {
    '#': '70',
    Library: 'hashes-1.8.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2022 Paul Miller "(https://paulmillr.com)" (https://paulmillr.com)'
  },
  {Copyrights: 'Copyright 2022 Paul Miller (https://paulmillr.com)'},
  {'#': '71', Library: 'hasown-2.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Jordan Harband and contributors'},
  {
    '#': '72',
    Library: 'helper-globals-7.28.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '73',
    Library: 'helper-module-imports-7.28.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '74',
    Library: 'helper-string-parser-7.27.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '75',
    Library: 'helper-validator-identifier-7.28.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '76', Library: 'helpers-0.5.21.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2024 SWC contributors'},
  {Copyrights: 'Copyright 2024 SWC contributors'},
  {'#': '77', Library: 'hoist-non-react-statics-3.3.2.tgz', Licenses: 'BSD 2', Copyrights: 'Copyright 2015 Yahoo!'},
  {'#': '78', Library: 'hsl-to-hex-1.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright David Mark Clements 2016'},
  {
    '#': '79',
    Library: 'hsl-to-rgb-for-reals-1.1.1.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright David Mark Clements 2019'
  },
  {
    '#': '80',
    Library: 'html-dom-parser-5.1.8.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 Menglin "Mark" Xu <mark@remarkablemark.org>'
  },
  {
    '#': '81',
    Library: 'html-react-parser-5.2.17.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2016 Menglin "Mark" Xu <mark@remarkablemark.org>'
  },
  {'#': '82', Library: 'html-to-image-1.11.13.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017-2025 W.Y'},
  {
    '#': '83',
    Library: 'htmlparser2-10.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2010-2011 Chris Winberry <chris@winberry.net>'
  },
  {
    '#': '84',
    Library: 'hyphen-1.14.1.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2026 Yevhen Tiurin <yevhentiurin@gmail.com>'
  },
  {'#': '85', Library: 'icons-material-5.18.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '86',
    Library: 'image-3.0.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {Copyrights: 'Copyright Diego Muracciole'},
  {'#': '87', Library: 'immer-11.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Michel Weststrate'},
  {Copyrights: 'Copyright 2017 Michel Weststrate'},
  {
    '#': '88',
    Library: 'import-fresh-3.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {'#': '89', Library: 'inherits-2.0.4.tgz', Licenses: 'ISC', Copyrights: 'Copyright Isaac Z'},
  {
    '#': '90',
    Library: 'inline-style-parser-0.2.7.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 TJ Holowaychuk <tj@vision-media.ca>'
  },
  {'#': '91', Library: 'is-arrayish-0.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '92', Library: 'is-arrayish-0.3.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 JD Ballard'},
  {'#': '93', Library: 'is-core-module-2.16.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Dave Justice'},
  {
    '#': '94',
    Library: 'is-prop-valid-1.4.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '95', Library: 'is-url-1.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright segment.com 2018'},
  {
    '#': '96',
    Library: 'jay-peg-1.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '97', Library: 'js-md5-0.8.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014-2023 Chen'},
  {
    '#': '98',
    Library: 'js-tokens-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2015 2016, 2017, 2018 Simon Lydell'
  },
  {Copyrights: 'Copyright 2014-2018 Simon Lydell'},
  {
    '#': '99',
    Library: 'jsesc-3.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Mathias Bynens <https://mathiasbynens.be/>'
  },
  {
    '#': '100',
    Library: 'json-parse-even-better-errors-2.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Kat Marchán'
  },
  {Copyrights: 'Copyright npm, Inc'},
  {'#': '101', Library: 'lab-5.0.0-alpha.177.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '102', Library: 'layout-4.5.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright diegomuracciole@gmail.com'},
  {'#': '103', Library: 'linebreak-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Devon Govett'},
  {'#': '104', Library: 'lines-and-columns-1.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Brian Donovan'},
  {
    '#': '105',
    Library: 'lodash-4.18.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright OpenJS Foundation and other contributors <https://openjsf.org/>'
  },
  {
    '#': '106',
    Library: 'lodash.debounce-4.0.8.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright jQuery Foundation and other contributors <https://jquery.org/>'
  },
  {
    '#': '107',
    Library: 'loose-envify-1.4.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2015 Andres Suarez <zertosh@gmail.com>'
  },
  {
    '#': '108',
    Library: 'marked-15.0.12.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2018 MarkedJS (https://github.com/markedjs/)'
  },
  {Copyrights: 'Copyright 2011-2018 Christopher Jeffrey'},
  {Copyrights: 'Copyright 2011-2022 Christopher Jeffrey'},
  {Copyrights: 'Copyright 2011-2018 Christopher Jeffrey'},
  {Copyrights: 'Copyright 2011-2022 Christopher Jeffrey'},
  {Copyrights: 'Copyright 2004 John Gruber'},
  {Copyrights: 'Copyright 2004 John Gruber'},
  {Copyrights: 'Copyright 2018 MarkedJS (https://github.com/markedjs/)'},
  {'#': '109', Library: 'material-5.18.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '110', Library: 'math-intrinsics-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 ECMAScript Shims'},
  {'#': '111', Library: 'media-engine-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole 2018'},
  {
    '#': '112',
    Library: 'memoize-0.9.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '113', Library: 'mitt-3.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Jason Miller'},
  {'#': '114', Library: 'ms-2.1.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Vercel, Inc'},
  {'#': '115', Library: 'msal-browser-3.30.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '116', Library: 'msal-common-14.16.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '117', Library: 'msal-react-2.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '118',
    Library: 'normalize-svg-path-1.1.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2008-2013 Dmitry Baranovskiy'
  },
  {Copyrights: 'Copyright 2013 Jake Rosoman "jkroso@gmail.com" (mailto:jkroso@gmail.com)'},
  {Copyrights: 'Copyright 2008-2013 Sencha Labs'},
  {
    '#': '119',
    Library: 'object-assign-4.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '120', Library: 'object-inspect-1.13.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 James Halliday'},
  {'#': '121', Library: 'optimism-0.18.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Ben Newman'},
  {'#': '122', Library: 'pako-0.2.9.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014-2016 by Vitaly Puzrin'},
  {
    '#': '123',
    Library: 'pako-1.0.11.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014-2017 by Vitaly Puzrin and Andrei Tuputcyn'
  },
  {
    '#': '124',
    Library: 'parent-module-1.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '125', Library: 'parse-json-4.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '126',
    Library: 'parse-json-5.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {
    '#': '127',
    Library: 'parse-svg-path-0.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2013 Jake Rosoman <jkroso@gmail.com>'
  },
  {'#': '128', Library: 'parser-7.29.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012-2014 various contributors'},
  {'#': '129', Library: 'path-parse-1.0.7.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Javier Blanco'},
  {
    '#': '130',
    Library: 'path-type-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {'#': '131', Library: 'pdfkit-5.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Devon Govett'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {Copyrights: 'Copyright Diego Muracciole'},
  {'#': '132', Library: 'picocolors-1.1.1.tgz', Licenses: 'ISC', Copyrights: 'Copyright 2021-2024 Oleksii Raspopov'},
  {'#': '133', Library: 'png-js-3.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017 Devon Govett'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {
    '#': '134',
    Library: 'postcss-value-parser-4.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Bogdan Chadkin <trysound@yandex.ru>'
  },
  {Copyrights: 'Copyright Bogdan Chadkin <trysound@yandex.ru>'},
  {
    '#': '135',
    Library: 'primitives-4.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {Copyrights: 'Copyright Diego Muracciole'},
  {'#': '136', Library: 'private-theming-5.17.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '137', Library: 'prop-types-15.7.15.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '138', Library: 'prop-types-15.8.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2013 Facebook, Inc'},
  {Copyrights: 'Copyright 2013 Facebook, Inc'},
  {'#': '139', Library: 'property-expr-2.0.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Jason Quense'},
  {
    '#': '140',
    Library: 'punycode-1.4.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Mathias Bynens <https://mathiasbynens.be/>'
  },
  {
    '#': '141',
    Library: 'qs-6.15.1.tgz',
    Licenses: 'BSD 3',
    Copyrights:
      'Copyright 2014 Nathan LaFreniere and other "contributors" https://github.com/ljharb/qs/graphs/contributors'
  },
  {
    '#': '142',
    Library: 'queue-6.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Jesse Tane <jesse.tane@gmail.com>'
  },
  {Copyrights: 'Copyright 2014 Jesse Tane "jesse.tane@gmail.com" (mailto:jesse.tane@gmail.com)'},
  {Copyrights: 'Copyright 2014 Jesse Tane <jesse.tane@gmail.com>'},
  {Copyrights: 'Copyright 2014 Jesse Tane "jesse.tane@gmail.com" (mailto:jesse.tane@gmail.com)'},
  {
    '#': '143',
    Library: 'react-11.14.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {
    '#': '144',
    Library: 'react-16.14.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {'#': '145', Library: 'react-18.3.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Facebook, Inc. and its affiliates'},
  {'#': '146', Library: 'react-copy-to-clipboard-5.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Nik Butenko'},
  {
    '#': '147',
    Library: 'react-dom-16.14.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '148',
    Library: 'react-dom-18.3.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {'#': '149', Library: 'react-dom-2.1.8.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '150', Library: 'react-hook-form-7.72.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 BeierBill Luo'},
  {
    '#': '151',
    Library: 'react-is-16.13.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '152',
    Library: 'react-is-19.2.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Meta Platforms, Inc. and affiliates'
  },
  {'#': '153', Library: 'react-mailto-link-1.0.9.tgz', Licenses: 'MIT', Copyrights: 'Copyright Jason Bellamy'},
  {Copyrights: 'Copyright Theo Mazars'},
  {'#': '154', Library: 'react-property-2.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright react property'},
  {'#': '155', Library: 'react-redux-9.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {
    '#': '156',
    Library: 'react-resize-detector-10.0.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2023 Vitalii Maslianok'
  },
  {
    '#': '157',
    Library: 'react-transition-group-4.4.12.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '158',
    Library: 'react-transition-group-4.4.5.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2013 Facebook, Inc'
  },
  {Copyrights: 'Copyright 2018 React Community'},
  {Copyrights: 'Copyright 2018 React Community'},
  {Copyrights: 'Copyright 2013 Facebook, Inc'},
  {
    '#': '159',
    Library: 'reconciler-2.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {'#': '160', Library: 'redux-5.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {
    '#': '161',
    Library: 'redux-promise-middleware-6.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2015 Patrick Burtchaell'
  },
  {'#': '162', Library: 'redux-thunk-3.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Dan Abramov'},
  {
    '#': '163',
    Library: 'regexparam-3.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)'
  },
  {'#': '164', Library: 'rehackt-0.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Lenz Weber-Tronic'},
  {'#': '165', Library: 'render-4.4.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {Copyrights: 'Copyright Diego Muracciole'},
  {'#': '166', Library: 'renderer-4.4.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright Diego Muracciole'},
  {Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'},
  {
    '#': '167',
    Library: 'require-from-string-2.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Vsevolod Strukchinsky <floatdrop@gmail.com> (github.com/floatdrop)'
  },
  {Copyrights: 'Copyright Vsevolod Strukchinsky'},
  {'#': '168', Library: 'reselect-5.1.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015-2018 Reselect Contributors'},
  {'#': '169', Library: 'resolve-1.22.11.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2012 James Halliday'},
  {
    '#': '170',
    Library: 'resolve-from-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'
  },
  {Copyrights: 'Copyright Sindre Sorhus'},
  {
    '#': '171',
    Library: 'resolve-uri-3.1.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019 Justin Ridgewell <jridgewell@google.com>'
  },
  {'#': '172', Library: 'resolvers-3.10.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Beier(Bill) Luo'},
  {'#': '173', Library: 'restructure-3.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Devon Govett'},
  {Copyrights: 'Copyright 2015 Devon Govett'},
  {
    '#': '174',
    Library: 'runtime-7.28.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '175', Library: 'safe-buffer-5.2.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright Feross Aboukhadijeh'},
  {Copyrights: 'Copyright Feross Aboukhadijeh'},
  {
    '#': '176',
    Library: 'scheduler-0.19.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '177',
    Library: 'scheduler-0.23.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {
    '#': '178',
    Library: 'scheduler-0.25.0-rc-603e6108-20241029.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Meta Platforms, Inc. and affiliates'
  },
  {
    '#': '179',
    Library: 'serialize-1.3.3.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {
    '#': '180',
    Library: 'sheet-1.4.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {'#': '181', Library: 'side-channel-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Jordan Harband'},
  {'#': '182', Library: 'side-channel-list-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {'#': '183', Library: 'side-channel-map-1.0.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Jordan Harband'},
  {'#': '184', Library: 'side-channel-weakmap-1.0.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Jordan Harband'},
  {'#': '185', Library: 'simple-swizzle-0.2.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Josh Junon'},
  {
    '#': '186',
    Library: 'source-map-0.5.7.tgz',
    Licenses: 'BSD 3',
    Copyrights: 'Copyright 2009-2011 Mozilla Foundation and contributors'
  },
  {
    '#': '187',
    Library: 'sourcemap-codec-1.5.5.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Justin Ridgewell <justin@ridgewell.name>'
  },
  {'#': '188', Library: 'spec-1.1.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Colin McDonnell'},
  {'#': '189', Library: 'string_decoder-1.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Node.js contributors'},
  {
    '#': '190',
    Library: 'style-to-js-1.1.21.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2020 Menglin "Mark" Xu <mark@remarkablemark.org>'
  },
  {
    '#': '191',
    Library: 'style-to-object-1.0.14.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Menglin "Mark" Xu <mark@remarkablemark.org>'
  },
  {
    '#': '192',
    Library: 'styled-11.14.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '193', Library: 'styled-engine-5.18.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {'#': '194', Library: 'stylesheet-6.1.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright diegomuracciole@gmail.com'},
  {'#': '195', Library: 'stylis-4.2.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2016 Sultan Tarimo'},
  {
    '#': '196',
    Library: 'supports-preserve-symlinks-flag-1.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2022 Inspect JS'
  },
  {
    '#': '197',
    Library: 'svg-arc-to-cubic-bezier-3.2.0.tgz',
    Licenses: 'ISC',
    Copyrights: 'Copyright 2017 `Colin Meinke`'
  },
  {Copyrights: 'Copyright 2017 "Colin Meinke"'},
  {'#': '198', Library: 'swr-2.4.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2023 Vercel, Inc'},
  {
    '#': '199',
    Library: 'symbol-observable-4.0.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2021 Ben Lesh <ben@benlesh.com>'
  },
  {Copyrights: 'Copyright 2021 Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)'},
  {'#': '200', Library: 'system-5.18.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '201',
    Library: 'template-7.28.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '202',
    Library: 'textkit-6.1.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2017 Diego Muracciole <diegomuracciole@gmail.com>'
  },
  {Copyrights: 'Copyright Diego Muracciole'},
  {'#': '203', Library: 'tiny-case-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright Jason Quense'},
  {'#': '204', Library: 'tiny-inflate-1.0.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2015 Devon Govett'},
  {'#': '205', Library: 'toggle-selection-1.0.6.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2017.0 sudodoki'},
  {'#': '206', Library: 'toolkit-2.11.2.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018 Mark Erikson'},
  {
    '#': '207',
    Library: 'toposort-2.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2012 by Marcel Klehr <mklehr@gmx.net>'
  },
  {
    '#': '208',
    Library: 'trace-mapping-0.3.31.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2024 Justin Ridgewell <justin@ridgewell.name>'
  },
  {
    '#': '209',
    Library: 'traverse-7.29.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {
    '#': '210',
    Library: 'trie-0.5.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2019-2021 Ben Newman <ben@eloper.dev>'
  },
  {'#': '211', Library: 'trusted-types-2.0.7.tgz', Licenses: 'MIT', Copyrights: 'Copyright Microsoft Corporation'},
  {'#': '212', Library: 'ts-invariant-0.10.3.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2019 Apollo GraphQL'},
  {'#': '213', Library: 'tslib-2.8.1.tgz', Licenses: 'BSD Zero', Copyrights: 'Copyright Microsoft Corporation'},
  {Copyrights: 'Copyright Microsoft Corporation'},
  {
    '#': '214',
    Library: 'type-fest-2.19.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)'
  },
  {Copyrights: 'Copyright and Related Rights (defined below) upon the creator'},
  {'#': '215', Library: 'types-2.10.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright Diego Muracciole'},
  {'#': '216', Library: 'types-7.2.24.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '217',
    Library: 'types-7.29.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Sebastian McKenzie and other contributors'
  },
  {'#': '218', Library: 'unicode-properties-1.4.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018'},
  {'#': '219', Library: 'unicode-trie-2.0.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2018'},
  {
    '#': '220',
    Library: 'unitless-0.10.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright 2016 Kye Hohenberger'},
  {
    '#': '221',
    Library: 'url-0.11.4.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Joyent, Inc. and other Node contributors'
  },
  {
    '#': '222',
    Library: 'use-insertion-effect-with-fallbacks-1.2.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {Copyrights: 'Copyright Emotion team and other contributors'},
  {
    '#': '223',
    Library: 'use-sync-external-store-0.0.6.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Microsoft Corporation'
  },
  {
    '#': '224',
    Library: 'use-sync-external-store-1.6.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Meta Platforms, Inc. and affiliates'
  },
  {
    '#': '225',
    Library: 'util-deprecate-1.0.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2014 Nathan Rajlich <nathan@tootallnate.net>'
  },
  {Copyrights: 'Copyright 2014 Nathan Rajlich "nathan@tootallnate.net" (mailto:nathan@tootallnate.net)'},
  {'#': '226', Library: 'utils-0.2.11.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Floating UI contributors'},
  {'#': '227', Library: 'utils-0.3.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2024 Fabian Hiller'},
  {
    '#': '228',
    Library: 'utils-1.4.2.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '229', Library: 'utils-5.17.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Call-Em-All'},
  {
    '#': '230',
    Library: 'vite-compatible-readable-stream-3.6.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Node.js contributors'
  },
  {
    '#': '231',
    Library: 'weak-memoize-0.4.0.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Emotion team and other contributors'
  },
  {'#': '232', Library: 'web-vitals-2.1.4.tgz', Licenses: 'Apache 2.0', Copyrights: 'Copyright 2020 Google LLC'},
  {'#': '233', Library: 'wouter-3.9.0.tgz', Licenses: 'Unlicense', Copyrights: 'Copyright molefrog@gmail.com'},
  {'#': '234', Library: 'x-date-pickers-7.29.4.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Material-UI SAS'},
  {'#': '235', Library: 'x-internals-7.29.0.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2020 Material-UI SAS'},
  {'#': '236', Library: 'yaml-2.8.3.tgz', Licenses: 'ISC', Copyrights: 'Copyright Eemeli Aro <eemeli@gmail.com>'},
  {
    '#': '237',
    Library: 'yoga-layout-3.2.1.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright Facebook, Inc. and its affiliates'
  },
  {'#': '238', Library: 'yup-1.7.1.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2014 Jason Quense'},
  {
    '#': '239',
    Library: 'zen-observable-0.8.15.tgz',
    Licenses: 'MIT',
    Copyrights: 'Copyright 2018 zenparsing (Kevin Smith)'
  },
  {Copyrights: 'Copyright 2018 zenparsing (Kevin Smith)'},
  {'#': '240', Library: 'zen-observable-ts-1.2.5.tgz', Licenses: 'MIT', Copyrights: 'Copyright 2021 Apollo Graph, Inc'}
]
